import { ExpenseCategory, IncomeCategory, PaymentMethod, PointProvider } from './types';

export const CATEGORY_COLORS: Record<string, string> = {
  // Expense
  [ExpenseCategory.FOOD]: '#FF8042',
  [ExpenseCategory.TRANSPORT]: '#0088FE',
  [ExpenseCategory.SHOPPING]: '#00C49F',
  [ExpenseCategory.ENTERTAINMENT]: '#FFBB28',
  [ExpenseCategory.UTILITIES]: '#8884d8',
  [ExpenseCategory.HOUSING]: '#82ca9d',
  [ExpenseCategory.HEALTH]: '#ff6b6b',
  [ExpenseCategory.EDUCATION]: '#4ecdc4',
  [ExpenseCategory.CHARGE]: '#00bcd4',
  [ExpenseCategory.OTHER]: '#95a5a6',
  
  // Income
  [IncomeCategory.SALARY]: '#2563eb', // Blue
  [IncomeCategory.BONUS]: '#7c3aed', // Purple
  [IncomeCategory.BUSINESS]: '#0891b2', // Cyan
  [IncomeCategory.ALLOWANCE]: '#16a34a', // Green
  [IncomeCategory.INVESTMENT]: '#ea580c', // Orange
  [IncomeCategory.RETURN]: '#db2777', // Pink
  [IncomeCategory.OTHER]: '#64748b', // Slate

  // Point
  'ポイント': '#fbbf24', // Amber
};

export const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  [PaymentMethod.CASH]: '現金',
  [PaymentMethod.CREDIT_CARD]: 'クレカ',
  [PaymentMethod.DEBIT_CARD]: 'デビット',
  [PaymentMethod.PREPAID_CARD]: 'プリペイド',
  [PaymentMethod.E_MONEY]: '電子マネー',
  [PaymentMethod.QR_CODE]: 'QR決済',
  [PaymentMethod.BANK_TRANSFER]: '振込',
  [PaymentMethod.POINTS]: 'ポイント',
  [PaymentMethod.OTHER]: 'その他',
};

export const PAYMENT_DETAILS: Partial<Record<PaymentMethod, string[]>> = {
  [PaymentMethod.E_MONEY]: ['Suica', 'PASMO', 'ICOCA', 'WAON', 'nanaco', 'QUICPay', 'iD', 'その他'],
  [PaymentMethod.QR_CODE]: ['PayPay', 'd払い', '楽天ペイ', 'au PAY', 'LINE Pay', 'メルペイ', 'FamiPay', 'その他'],
  [PaymentMethod.PREPAID_CARD]: ['Kyash', 'au PAY プリペイド', 'dカード プリペイド', 'バンドルカード', 'その他'],
};

export const POINT_PROVIDER_LABELS: Record<PointProvider, string> = {
  [PointProvider.PAYPAY]: 'PayPay',
  [PointProvider.RAKUTEN]: '楽天',
  [PointProvider.DPOINT]: 'dポイント',
  [PointProvider.PONTA]: 'Ponta',
  [PointProvider.VPOINT]: 'Vポイント',
  [PointProvider.OTHER]: 'その他',
};

export const POINT_COLORS: Record<PointProvider, string> = {
  [PointProvider.PAYPAY]: 'bg-red-500',
  [PointProvider.RAKUTEN]: 'bg-red-600', // Rakuten Red
  [PointProvider.DPOINT]: 'bg-red-400', // Docomo Red
  [PointProvider.PONTA]: 'bg-orange-500',
  [PointProvider.VPOINT]: 'bg-yellow-500', // T-Point/V-Point Yellow
  [PointProvider.OTHER]: 'bg-gray-400',
};